import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import DataTable from 'react-data-table-component';
import { get, del, put, post } from '../../controllers/apiController';

import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

const Temsilciler = () => {
    const [isLoading, setIsLoading] = useState(true);

    const [agents, setAgents] = useState([]);
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [createFormData, setCreateFormData] = useState({
        name: "",
        surname: "",
        email: "",
        password: ""
    });
    const [showEditModal, setShowEditModal] = useState(false);
    const [editFormData, setEditFormData] = useState({
        id: null,
        name: "",
        surname: "",
        email: ""
    });

    const fetchAgents = async () => {
        try {
            const res = await get("users/company-users");

            setAgents((res || []).filter(u => u.Kullanici_Yetki == 1));

            setIsLoading(false);
        } catch (err) {
            toast.error("Veriler alınırken bir hata oluştu!");
        }
    }

    useEffect(() => {
        document.title = "Temsilciler | LEVELUP CRM";

        fetchAgents();
    }, []);

    const paginationComponentOptions = {
        rowsPerPageText: 'Sayfa başına satır:',
        rangeSeparatorText: 'toplam',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Tümü',
        firstPageText: 'İlk',
        previousPageText: 'Önceki',
        nextPageText: 'Sonraki',
        lastPageText: 'Son',
        noRowsPerPage: false,
    };

    const customStyles = {
        noData: {
            style: {
                padding: '24px',
                textAlign: 'center',
            },
        },
    };

    const handleDelete = async (id) => {
        Swal.fire({
            title: 'Temsilci silinsin mi?',
            icon: 'error',
            showCancelButton: true,
            confirmButtonText: 'Sil',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await del(`users/${id}`);

                    setAgents(agents.filter(agent => agent.Kullanici_ID !== id));

                    toast.success('Temsilci başarıyla silindi');
                } catch (error) {
                    console.error('Temsilci silme hatası:', error?.response?.status, error?.response?.data);
                    toast.error(error?.response?.data?.message || error?.response?.data?.error || 'Temsilci silinirken bir hata oluştu');
                }
            }
        })

    }

    const handleCreate = () => {
        setShowCreateModal(true);
    }

    const handleCreateSubmit = async (e) => {
        e.preventDefault();
        try {

            if (createFormData.name == "" || createFormData.surname == "" || createFormData.email == "" || createFormData.password == "") {
                toast.error("Tüm alanları doldurmalısınız!");
                return;
            }

            await post('users', {
                name: createFormData.name,
                surname: createFormData.surname,
                email: createFormData.email,
                password: createFormData.password,
                permission: 1
            });

            setCreateFormData({
                name: "",
                surname: "",
                email: "",
                password: ""
            });

            await fetchAgents();
            setShowCreateModal(false);
            toast.success('Temsilci başarıyla eklendi!');
        } catch (error) {
            toast.error('Temsilci eklenirken bir hata oluştu');
        }
    }

    const handleEdit = (row) => {
        setEditFormData({
            id: row.Kullanici_ID,
            name: row.Kullanici_Adi,
            surname: row.Kullanici_Soyadi,
            email: row.Kullanici_Email
        });
        setShowEditModal(true);
    }

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        try {

            if (editFormData.name == "" || editFormData.surname == "" || editFormData.email == "") {
                toast.error("Tüm alanları doldurmalısınız!");
                return;
            }

            await put(`users/${editFormData.id}`, {
                name: editFormData.name,
                surname: editFormData.surname,
                email: editFormData.email,
                permission: 1
            });

            await fetchAgents();
            setShowEditModal(false);
            toast.success('Temsilci başarıyla güncellendi!');
        } catch (error) {
            toast.error('Temsilci güncellenirken bir hata oluştu');
        }
    }

    const columns = [
        {
            name: 'Kullanıcı Adı',
            sortable: true,
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">{row.Kullanici_Adi}</span>
            )
        },
        {
            name: 'Temsilci Adı',
            sortable: true,
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">{row.Kullanici_Adi}</span>
            )
        },
        {
            name: 'Temsilci Soyadı',
            sortable: true,
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">{row.Kullanici_Soyadi}</span>
            )
        },
        {
            name: 'Temsilci Email',
            sortable: true,
            cell: row => (
                <span className="text-truncate-1-line fw-semibold">{row.Kullanici_Email}</span>
            )
        },
        {
            name: 'Aksiyon',
            cell: row => (
                <div className="d-flex gap-2">
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleEdit(row)}>
                        <i className="feather feather-edit-2 fs-6"></i>
                    </a>
                    <a href="#!" className="avatar-text avatar-md" onClick={() => handleDelete(row.Kullanici_ID)}>
                        <i className="feather feather-trash fs-6"></i>
                    </a>
                </div>
            )
        }
    ];

    const modalBackdropStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        zIndex: 1040
    };

    return (
        <Layout>
            <main className="nxl-container">
                <div className="nxl-content">
                    <div className="page-header">
                        <div className="page-header-left d-flex align-items-center">
                            <div className="page-header-title">
                                <h5 className="m-b-10">LEVELUP CRM</h5>
                            </div>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item"><a href="./">Anasayfa</a></li>
                                <li className="breadcrumb-item">Temsilciler</li>
                            </ul>
                        </div>
                    </div>
                    <div className="main-content">
                        <div className="row">
                            <div className="col-xxl-12 col-md-12">
                                <div className="card stretch stretch-full">
                                    <div className="card-header">
                                        <h5 className="card-title">Tüm Temsilciler</h5>
                                        <div className="card-header-action">
                                            <button onClick={handleCreate} className="btn btn-light">
                                                <i className="feather-plus"></i>
                                                Yeni Ekle
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body custom-card-action p-2">
                                        {isLoading ? (
                                            <div className="w-100 d-flex align-items-center justify-content-center spinner-wrapper">
                                                <div class="spinner-border text-primary" role="status">
                                                    <span class="visually-hidden">Yükleniyor...</span>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="table-responsive mb-3">
                                                <DataTable
                                                    columns={columns}
                                                    data={agents}
                                                    className="table table-hover mb-0"
                                                    pagination
                                                    responsive
                                                    noDataComponent="Görüntülenecek kayıt bulunamadı"
                                                    paginationComponentOptions={paginationComponentOptions}
                                                    customStyles={customStyles}
                                                    paginationPerPage={10}
                                                    paginationRowsPerPageOptions={[10, 25, 50, 100]}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {showCreateModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Temsilci Oluştur</h5>
                                <button type="button" className="btn-close" onClick={() => setShowCreateModal(false)}></button>
                            </div>
                            <form onSubmit={handleCreateSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Adı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={createFormData.name}
                                            onChange={(e) => setCreateFormData({ ...createFormData, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Soyadı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={createFormData.surname}
                                            onChange={(e) => setCreateFormData({ ...createFormData, surname: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={createFormData.email}
                                            onChange={(e) => setCreateFormData({ ...createFormData, email: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Şifre</label>
                                        <input
                                            type="password"
                                            className="form-control"
                                            value={createFormData.password}
                                            onChange={(e) => setCreateFormData({ ...createFormData, password: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowCreateModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary">Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {showCreateModal && (
                <div style={modalBackdropStyle} onClick={() => setShowCreateModal(false)} />
            )}

            {showEditModal && (
                <div className="modal fade show" style={{ display: 'block' }}>
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Temsilci Düzenle</h5>
                                <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                            </div>
                            <form onSubmit={handleEditSubmit}>
                                <div className="modal-body">
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Adı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editFormData.name}
                                            onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Soyadı</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editFormData.surname}
                                            onChange={(e) => setEditFormData({ ...editFormData, surname: e.target.value })}
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label className="form-label">Temsilci Email</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            value={editFormData.email}
                                            onChange={(e) => setEditFormData({ ...editFormData, email: e.target.value })}
                                        />
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowEditModal(false)}>İptal</button>
                                    <button type="submit" className="btn btn-primary">Kaydet</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            {showEditModal && (
                <div style={modalBackdropStyle} onClick={() => setShowEditModal(false)} />
            )}
        </Layout>
    );
};

export default Temsilciler;
